import {useMemo} from 'react';
import {IProductShort} from 'modules/products/types';

export const useProductRatings = (product: IProductShort) => {
    return useMemo(() => {
        const {ratings, url} = product;

        const sortedRatings = [...(ratings || [])].sort((a, b) => {
            if ('REVIEWS' === a.code) {
                return -1;
            }
            if ('REVIEWS' === b.code) {
                return 1;
            }
            return 0;
        });

        const reviewsUrl = `${url}reviews`;

        return {
            ratings: sortedRatings,
            reviewsUrl,
        };
    }, [product]);
};
